<template>
  <main>
    <video-banner></video-banner>

    <b-container fluid="lg" class="w-100">
      <b-row class="main-margin">
        <b-col class="d-flex justify-content-center">
          <div class="full-width">
            <b-row>
              <b-col>
                <h4
                  class="
                    text-uppercase
                    about-absis-title about-titles about-absis
                  "
                >
                  Absis vision og mission
                </h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p class="about-absis-content about-absis">
                  Organiseret modkøb (Barter) stammer fra Schweiz, hvor man i
                  1934 startede virksomheden WIR, der i dag har over 65.000
                  virksomheder som medlemmer. absi har eksisteret i Danmark
                  siden 2003 og er den tredje virksomhed i verden, der
                  introducerer et betalingskort til multilateral modkøbshandel.
                  Idag tilbyder vi både digital- og mobilbetaling som
                  supplement. I 2021 består absi af over 800 virksomheder og ca.
                  10.000 gavekortholdere – sammen styrker vi små og mellemstore
                  virksomheder.
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h4
                  class="
                    text-uppercase
                    about-vision-title about-titles about-absis
                  "
                >
                  Absis vision
                </h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p class="about-vision-content about-absis">
                  At styrke samspillet blandt små og mellemstore virksomheder,
                  at skabe loyalitet og godt købmandskab.
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h4
                  class="
                    text-uppercase
                    about-mission-title about-titles about-absis
                  "
                >
                  Mission
                </h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p class="about-mission-content about-content about-absis">
                  Udvikle og implementere nye ideer, processer, koncepter og
                  teknologier, der øger samhandlen og loyaliteten mellem
                  virksomheder, og derved styrker konkurrenceevnen hos vores
                  kunder.
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h4
                  class="
                    text-uppercase
                    about-values-title about-titles about-absis
                  "
                >
                  Grundlæggende værdier
                </h4>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h5
                  class="about-values-innovative about-undertitles about-absis"
                >
                  <strong> Innovative </strong>
                </h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p class="values-innovative-content about-content about-absis">
                  Vi har et helt team til at udtænke og udarbejde nye idéer og
                  teknologi, sådan er vores app og betalingsløsninger blevet
                  til.
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h5
                  class="about-values-proactive about-undertitles about-absis"
                >
                  <strong> Proaktive </strong>
                </h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p class="values-proactive-content about-content about-absis">
                  Vi agerer frem for at reagere – personlig kontakt er
                  værdiskabende for os både blandt medlemmer og kollegaer.
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h5
                  class="about-values-trustworthy about-undertitles about-absis"
                >
                  <strong> Troværdighed </strong>
                </h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p class="values-trustworthy-content about-content about-absis">
                  Systemer og teknologi, der virker og aftaler overholdes. Vi
                  siger garanti for nye kunder fordi vi mener det.
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h5
                  class="
                    about-values-professional about-undertitles about-absis
                  "
                >
                  <strong> Professionelle </strong>
                </h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p
                  class="values-professional-content about-content about-absis"
                >
                  Vi har et helt team til at udtænke og udarbejde nye idéer og
                  teknologi, sådan er vores app og betalingsløsninger blevet
                  til.
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h5 class="about-values-humor about-undertitles about-absis">
                  <strong> Humor </strong>
                </h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p class="values-humor-content about-content about-absis">
                  Vi fører en respektfuld tone overfor kunder og medarbejdere,
                  med en humoristisk kommentar til tider.
                </p>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import VideoBanner from "@/components/VideoBanner.vue";

export default {
  name: "About",
  components: {
    VideoBanner,
  },
};
</script>

<style lang="scss" scoped>
.about-absis {
  text-align: center;
}
.about-titles {
  color: $primary;
  font-family: $medium;
  font-size: $titles;
}
.about-undertitles {
  margin-top: 10px;
  font-size: $under-title;
}

.about-content {
  font-size: $content;
}
</style>